export const cardVariants = {
  hover: {
    scale: 1.1,
  },
}
